module.exports = __webpack_public_path__ + "img/fire-icon.73567937.png";